export default __webpack_public_path__ + "static/media/check.cfd1e643.svg";